module.exports = __webpack_public_path__ + "static/VidCtrlMap-1df8aca8b2e491899c81aa903282fec4.mp4";